import React, { useEffect, useState } from 'react';
import { Autocomplete } from '@material-ui/lab';

function AutocompleteInput(props) {
  const [prevValue, setPrevValue] = useState(props.value);
  const [key, setKey] = useState(0);
  useEffect(() => {
    if (props.value !== prevValue) {
      setPrevValue(props.value);
      setKey(key + 1);
    }
  }, [props.value, prevValue]);


  return <Autocomplete
    blurOnSelect='touch'
    {...props}
    key={key}
  />;
}

export default AutocompleteInput;
